<template>
    <BaseDialog
        :showDialog="showConfirmationDialog"
        maxDialogWidth="500"
        maxCardHeight="500"
        headline="lang_PUBLISHING_WORKS_CAPTION_WORKS_BULK_EDITING_CONFIRM_DIALOG_TITLE"
        :close="closeDialog"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">
                        {{ $t("lang_PUBLISHING_WORKS_CAPTION_WORKS_BULK_EDITING_CONFIRM_DIALOG_TEXT") }}
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-container>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="userInput"
                            :messages="$t(errorMessage)"
                            depressed
                            @keydown.enter="checkUserInput()"
                            class="ml-0 mr-0"
                            :label="confirmationValue"
                            :alvqa="alvqa + '-textfield-confirm'"
                            autofocus
                        ></v-text-field>
                    </v-col>
                    <v-col class="text-right" align-self="center">
                        <BaseButton
                            @click="checkUserInput()"
                            label="lang_GENERAL_CONFIRM"
                            :alvqa="alvqa + '-button-confirm'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
        
    </BaseDialog>
</template>
<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "WorksBulkEditingConfirmDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    data() {
        return {
            context: "WorksBulkEditingConfirm",
            userInput: '',
            errorMessage: '',
            alvqa: "publishing-works-action-option-works-bulk-editing-confirm-dialog",

            resolvePromise: undefined,
        }
    },
    computed: {
        showConfirmationDialog: {
            get() { return this.$store.getters.getShowWorksBulkEditingConfirmDialog },
            set(showConfirmationDialog) { this.$store.commit('setShowWorksBulkEditingConfirmDialog', showConfirmationDialog) }
        },
        confirmationValue() {
            let value = this.$store.getters.getSelectedWorks.length
            if (this.$store.getters.getBulkEditingAllWorks)
                value = this.$store.getters.getTotalListed
            return value.toString()
        },
        actionToConfirm: {
            get() { return this.$store.getters.getWorksBulkEditingActionToConfirm },
            set(value) { this.$store.commit('setWorksBulkEditingActionToConfirm', value) }
        }
    },
    methods: {
        openDialog() {
            this.showConfirmationDialog = true
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
            })
        },        
        continueAction() {
            let actionFromTo = "from "
            
            // Retrieve society name that is checked as source by the user (it is stored as ID so we need to get it's name by that ID)
            let societyFrom = this.$store.getters.getSocieties.find(society => {
                return society.value.toString() === this.$store.getters.getWorksBulkEditingDetailsSourceShare
            })
            if (societyFrom !== undefined) {
                let societyName = this.$alvPlugin.getSocietyName(parseInt(societyFrom.value)) + '-' + this.$t('lang_GENERAL_CAPTION_SHARES')
                actionFromTo += societyName
            } else {
                actionFromTo += `id ${this.$store.getters.getWorksBulkEditingDetailsSourceShare}`
            }

            switch (this.actionToConfirm) {
                case "copyShares":
                    this.$store.commit('setBulkEditCopySharesReportCsv', null) // remove filepath and thereby download icon, i.e. from previous run
                    this.$store.dispatch('copyShares', {dir: this.dir, context: this.context, ids: this.idAttributeName })
                    actionFromTo += ` to ${this.$store.getters.getWorksBulkEditingDetailsTargetShare}`
                    break
                case "fillOriginalShares":
                    this.$store.commit('setBulkEditFillOriginalSharesReportCsv', null) // remove filepath and thereby download icon, i.e. from previous run
                    this.$store.dispatch('fillOriginalShares', {dir: this.dir, context: this.context, ids: this.idAttributeName })
                    actionFromTo += ` to ${this.$store.getters.getWorksBulkEditingDetailsFillOriginalShares}`
                    break
                case "combineEShares":
                    this.$store.dispatch('combineEShares', {dir: this.dir, context: this.context, ids: this.idAttributeName }).then(() => {
                        this.$store.commit('setSnackbar', {
                            type: 'success',
                            msg: this.$t('lang_PROCESS_COMPLETED')
                        })
                    })
                    actionFromTo = ` Combine E shares in ${this.$store.getters.getWorksBulkEditingDetailsTargetShareCombineE}%`
                    break
            }

            // Mixpanel tracking
            let action = this.context + ` ${this.actionToConfirm} (${actionFromTo})` 
            let entities = this.$store.getters['getSelectedWorks']
            mixpanel.track(action , {
                'entityIds': entities,
                'routePath': this.$route.path,
                'userId': this.$store.getters.getUser.id,
            });
            this.closeDialog(true)
        },
        closeDialog(isSuccessful = false) {
            this.showConfirmationDialog = false
            this.userInput = ''
            this.errorMessage = ''
            this.actionToConfirm = null
            if (isSuccessful == true)
                this.resolvePromise(true)
            else
                this.resolvePromise(false)
        },
        checkUserInput() { 
            if(this.userInput == this.confirmationValue) this.continueAction()
            else this.errorMessage = 'lang_PUBLISHING_WORKS_CAPTION_WORKS_BULK_EDITING_CONFIRM_DIALOG_VALIDATION_ERROR'
        }
    }
}
</script>